import { Link } from "react-router-dom";

import { IUser } from "services/types";
import { nFormatter } from "utils/parseNumber";
import { Image } from "components";
import { VerifiedTick } from "components/buttons";
import { routes } from "routes";

import USER_ICON from "components/icons/profileIcon.svg";
import DEFAULT_USERPIC from "components/icons/default_userpic.svg";

import "./CreatorTile.scss";

export const CreatorTile = (props: {
  user: IUser;
}): JSX.Element => {
  const { user } = props;

  const image = user.profileImageUrl
    ?? user.poster
    ?? DEFAULT_USERPIC;

  return (
    <div className="creatorTile">
      <Link to={routes.user(user.username)}>
        <img className="thumbnail" src={image} alt="" />
        <div className="shadow"></div>
        <div className="meta">
          <div className="userName">{user.name ?? user.username}</div>
          <div className="counter">
            <Image className="icon" src={USER_ICON} />
            {nFormatter(user.followers)}
          </div>
        </div>
        {props.user.verified && (
          <VerifiedTick hint="Verified creator" />
        )}
      </Link>
    </div>
  );
};
